import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { SecurityView } from '@mews-commander/modules/src/modules/settings';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => <SecurityView guideLink={createGuideLink(ArticlePath.ChangeYourUserAccountInformation)} />;

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Profile/Security')({
    component: Component,
    staticData: {
        routeName: RouteName.ProfileSecurity,
        owner: MewsTeam.Users,
        title: TextKey.PrivacyAndSecurity,
        type: RouteType.Frontend,
    },
});
